import React,{useEffect}  from 'react'
import Btn from './btn'
import {localestr} from '../utils'
import { playSound } from '../helpers/playSoundHelper'


function MsgSound({soundMode, Text,caption,sound,setModal,actions,id,type=1}){
    let btn=<Btn Cls='select' Stl={{minWidth:'48px'}} btnClick={()=>{setModal('')}}>{localestr('Закрити')}</Btn>
    if(actions) {
      btn=actions.map((el,idx)=>{
        if(el.no_close) return(<Btn key={idx} Cls='select' Stl={{minWidth:'48px'}} btnClick={()=>{el.action()}}>{el.caption}</Btn>)
        else return(<Btn key={idx} Cls='select'  Stl={{minWidth:'48px'}} btnClick={()=>{setModal('');el.action()}}>{el.caption}</Btn>)
      })  
    }

    let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;

    function dragMouseDown(e) {
      e = e || window.event;
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    }
    
    function elementDrag(e) {
      const elmnt=document.getElementById('modalWnd'+id)
      e = e || window.event;
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      if (pos2!==0) elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
      if (pos1!==0) elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }
  
    function closeDragElement() {
      /* stop moving when mouse button is released:*/
      document.onmouseup = null;
      document.onmousemove = null;
    }

    function tick(){
        // const audio = new Audio()
        // audio.preload = 'auto'
        // audio.src = sound
        // audio.play()
        playSound(soundMode, sound);
    }

    useEffect(() => {
      //console.log('effect2')
      const intervalHandle=setInterval(tick,3000)
      return () => clearInterval(intervalHandle)
    // eslint-disable-next-line 
    },[])

    if (type===1){
      return(
          <div className='modal'><div id={'modalWnd'+id} className='window'>
              <div className='no-print' onMouseDown={dragMouseDown} style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}}><div className='caption'>{caption||localestr('Повідомлення')}</div><div className='closebtn' onClick={()=>{setModal('')}}/></div>
              <div className='content'>
              <div style={{margin:'0 0 0 0',display:'flex',justifyContent:'center',whiteSpace:'pre-wrap'}}>
                  {Text}
              </div>
              <div className='no-print' style={{margin:'10px 0 0 0',display:'flex',justifyContent:'center'}}>
              {btn}
              </div></div>
          </div></div>
      )
    }
}

export default MsgSound